import React, { useState } from "react";
import {
	Button,
	Form,
	Modal
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LS_AUTHORITY_KEY } from "../../../core/constants/common";
import KPIService from "../../../core/service/KPIService";
import Utils from "../../../core/utilities/Utils";

function KPICategoryModal({ t, categoryToUpdate, onHide, onSave }) {

	const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const [category, setCategory] = useState(categoryToUpdate?.category ?? '');
	const [validated, setValidated] = useState(false);

	const saveData = () => {
		if (Utils.isEmpty(category)) {
			setValidated(true);
			return;
		}
		let req;
		if (categoryToUpdate?.id > 0) {
			req = KPIService.updateKPICategory({ id: categoryToUpdate?.id, ownerId: lsData.profile.company.id, category: category });
		} else {
			req = KPIService.createKPICategory({ ownerId: lsData.profile.company.id, category: category });
		}
		req?.then(res => {
			if (res.status !== 200 && res.status !== 201) return;

			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
			onSave();
		}).catch((error) => { });
		setValidated(false);
	};

	return (
		<>
			<Modal show={true} onHide={() => onHide()}
				aria-labelledby="contained-modal-title-vcenter"
				size="lg"
				centered>
				<Modal.Header closeButton className="border-0">
					< Modal.Title as="h5">{ categoryToUpdate?.id > 0 ?  t('UpdateCategory.label') : t('NewCategory.label')}</Modal.Title>
				</Modal.Header>
				<Modal.Body className="">
					<Form noValidate validated={validated}>
						<div className="p-2">
							<label>Name</label>
							<input
								type="text"
								className="form-control"
								onChange={(e) => setCategory(e.target.value)}
								value={category}
								required />
						</div>
					</Form>
					<div className="text-center p-2">
						<Button variant="secondary" className="mx-2" onClick={() => onHide()}>{t('Cancel.label')}</Button>
						<Button variant="primary" onClick={() => saveData()}>{t('Save.label')}</Button>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
}

export default withTranslation()(KPICategoryModal);

